import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/animations.css';
import './index.css';
import './styles/buttons.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
